var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "cumulative_bar"
  }, [_c('div', {
    ref: "agg_bar",
    staticClass: "agg_bar",
    style: {
      width: "".concat(_vm.barPerc, "%")
    }
  }, [_c('div', {
    staticClass: "now_bar",
    style: {
      width: "".concat(_vm.nowPerc, "%")
    }
  })])]);
}
var staticRenderFns = []

export { render, staticRenderFns }